/**
 * Первый модуль, который исполняется. Код авторизации в адресе стоит столько же, сколько
 * токен: его забирают и стирают из адресной строки раньше, чем запустится что-либо ещё —
 * роутер, SDK, сервис-воркер. `main.ts` импортирует этот файл первым.
 */
import { readAuthCallback } from './core/auth/callback';

export const authCallback = readAuthCallback();
